import { useEffect, useState } from 'react'
import { getJson, type TriggerSources } from './types'

/** Dashboard outages must not block opening the editor for other source kinds. */
export default function useDashboardAnalyses(initial: TriggerSources, enabled: boolean, url: string) {
  const [loaded, setLoaded] = useState<{ url: string; values: Pick<TriggerSources, 'analyses' | 'analyses_error'> } | null>(null)
  const [busy, setBusy] = useState(false)
  const current = loaded?.url === url ? loaded.values : null

  useEffect(() => {
    if (!enabled || !initial.analyses_deferred || current) return
    const controller = new AbortController()
    setBusy(true)
    getJson<Pick<TriggerSources, 'analyses' | 'analyses_error'>>(url, controller.signal)
      .then((values) => { if (!controller.signal.aborted) setLoaded({ url, values }) })
      .catch((error: Error) => {
        if (!controller.signal.aborted) setLoaded({ url, values: { analyses: [], analyses_error: error.message } })
      })
      .finally(() => { if (!controller.signal.aborted) setBusy(false) })
    return () => { controller.abort(); setBusy(false) }
  }, [enabled, initial.analyses_deferred, current, url])

  return { sources: { ...initial, ...current }, busy }
}
